module.exports = __webpack_public_path__ + "img/img_pocket_emblem.43d0a596.png";